/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUnitPriceRequest {
    getFixupPrototypeFunction() { return ResourceUnitPriceRequest.fixupPrototype; }

    static newInstance(model: Partial<ResourceUnitPriceRequest>): ResourceUnitPriceRequest {
        let obj = Object.assign(new ResourceUnitPriceRequest(), model);
        ResourceUnitPriceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUnitPriceRequest>): ResourceUnitPriceRequest {
        if (!model) return null;
        return ResourceUnitPriceRequest.newInstance(<ResourceUnitPriceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUnitPriceRequest) {
        if (!obj) return;

        models.ResourceUnitPriceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUnitPriceRequest): boolean {
        Object.setPrototypeOf(obj, ResourceUnitPriceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the service account
     */
    service_account_id: string;

    /**
     * Id of the resource
     */
    resource_id: string;

    /**
     * Type of the resource
     */
    resource_type: string;

}
